module.exports = __webpack_public_path__ + "img/pftwx.00f05188.png";